export default __webpack_public_path__ + "static/media/help_support_icon.989ec55e.svg";